let lockCount = 0;

// Brings `el` just below the fixed header. Measures a frame later because
// swapping a tall form for a short confirmation changes the page height.
export const scrollToElement = (el, offset = 100) => {
  if (!el) return;
  requestAnimationFrame(() => {
    const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset);
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  });
};

export const lockScroll = () => {
  lockCount += 1;
  if (lockCount === 1) {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }
};

export const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }
};
